import { motion } from "framer-motion";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_melting-moments-1/artifacts/mfe7l5w4_Screenshot%202026-04-14%20at%208.10.43%20PM.png";
const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/4a0ea250-f6fc-48ff-a7d5-e3a33fb3e392/images/648616368a1d5881f360933d29340215c6f9801637aed95d5a6698922e01ae79.png";

const ease = [0.16, 1, 0.3, 1];

export default function HeroSection() {
  const scrollToProducts = () => {
    const el = document.getElementById("dual-experience");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/60 to-[#050505]" />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center text-center px-6">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.5, ease }}
          className="mb-8"
        >
          <img
            src={LOGO_URL}
            alt="YY Atelier"
            data-testid="hero-logo"
            className="w-40 md:w-56 lg:w-64 h-auto gold-glow mix-blend-lighten"
          />
        </motion.div>

        {/* Divider */}
        <motion.div
          initial={{ width: 0 }}
          animate={{ width: 60 }}
          transition={{ duration: 1.2, delay: 0.5, ease }}
          className="h-px bg-[#C6A96B] mb-10"
        />

        {/* Tagline */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.8, ease }}
          data-testid="hero-tagline"
          className="font-heading text-5xl md:text-6xl lg:text-7xl font-light tracking-tighter text-[#FDFBF7] mb-6"
        >
          Two That Melt as One.
        </motion.h1>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.2, ease }}
          className="font-body text-sm md:text-base font-light tracking-[0.15em] text-[#A3A3A3] mb-14 max-w-md"
        >
          Chocolates that only exist in pairs. Never alone. Always together.
        </motion.p>

        {/* CTA */}
        <motion.button
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 1.5, ease }}
          onClick={scrollToProducts}
          data-testid="explore-pair-btn"
          className="btn-luxury"
        >
          <span>Explore the Pair</span>
        </motion.button>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2.5, duration: 1 }}
        className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3"
      >
        <span className="font-body text-[10px] uppercase tracking-[0.3em] text-[#A3A3A3]">
          Scroll
        </span>
        <motion.div
          animate={{ y: [0, 8, 0] }}
          transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
          className="w-px h-8 bg-gradient-to-b from-[#C6A96B] to-transparent"
        />
      </motion.div>
    </section>
  );
}
